// ref: https://zenn.dev/meijin/articles/34b9482dbc856d2523ed
import { reactive, Ref, toRefs } from "vue";
import axios, { AxiosError } from "axios";

type useApiResult<T> = {
  handleApi: () => Promise<T | null>;
  errors: Ref<ApiErrorResponse | null>;
  loading: Ref<boolean>;
  isShowCreateSuccessMessage: Ref<boolean>;
};

type ApiErrorResponse = {
  messages: string[];
  status: number;
  reason: Record<string, string>;
};

export type useApi = {
  <T>(apiFunc: () => Promise<T>): useApiResult<T>;
};

export const useApi: useApi = (apiFunc) => {

  const state = reactive<{
    errors: ApiErrorResponse | null;
    loading: boolean;
    isShowCreateSuccessMessage: boolean;
  }>({
    errors: null,
    loading: false,
    isShowCreateSuccessMessage: false
  });

  const closeSuccessMessage = () => {
    state.isShowCreateSuccessMessage = false;
  };

  const handleApi = async () => {
    state.loading = true;

    return await apiFunc()
      .then((apiResponse) => {
        state.errors = null;
        state.isShowCreateSuccessMessage = true;
        return apiResponse;
      })
      .catch((err: AxiosError) => {
        // axiosを使っている前提で書いているので要注意
        if (axios.isAxiosError(err)) {
          state.errors = {
            messages: err.response?.data?.messages,
            status: err.response?.status || 500,
            reason: err.response?.data,
          };
        }
        return null;
      })
      .finally(() => {
        state.loading = false;
        setTimeout(closeSuccessMessage, 2000);
      });
  };

  return {
    handleApi,
    ...toRefs(state),
  };
};
